import React, {useEffect, useState} from 'react';
import {Button, Typography} from '@mui/material';
import {removeCrisisMaterials} from './RiskCrisis';
import {formatErrorMessage} from '../section_sf/NoBcp';
import {BasePopup, SuccessPopup} from '../shared/popups/BasePopup.jsx';
import {StyledCircularProgress} from '../shared/_snippets.jsx';

/**
 * @param {Object} crisisDetails
 * @param {Array} materialsToDelete
 * @param {number} totalRowCount
 * @param {function(string)} throwError
 * @param {function()} onClose
 * @param {function(number)} handleUpdate(removedRowsCount)
 * @return {JSX.Element}
 * @constructor
 */
export const RemoveMaterialsPopup = ({crisisDetails, materialsToDelete, totalRowCount, throwError, onClose, handleUpdate}) => {
    const [showConfirm, setShowConfirm] = useState(true);
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [removeMaterialsCount, setRemoveMaterialsCount] = useState(0);

    const handleClose = () => {
        setShowConfirm(false);
        setShowSuccess(false);
        onClose();
    };

    // safety checks
    useEffect(() => {
        if (materialsToDelete.length === 0) {
            throwError(null, 'No entries to remove were selected. Please select some materials.');
            handleClose();
        }
        if (materialsToDelete.length === totalRowCount) {
            throwError(null, 'Cannot remove all the entries from a crisis, as this would delete the crisis completely.\nPlease use the dedicated delete crisis button if deleting the crisis is desired.');
            handleClose();
        }
    });

    const handleRemoveMaterials = async () => {
        setLoading(true);
        removeCrisisMaterials(crisisDetails, materialsToDelete)
            .then((result) => {
                if (result.statusCode) {
                    throwError(null, formatErrorMessage(result, 'An error occurred while removing entries'));
                    handleClose();
                } else {
                    setShowConfirm(false);
                    setRemoveMaterialsCount(materialsToDelete.length);
                    setShowSuccess(true);
                }
                setLoading(false);
            });
    };

    if (loading) {
        return <BasePopup
            content={<StyledCircularProgress />}
            onClose={handleClose}
        />;
    } else if (showConfirm) {
        return <BasePopup
            title='Confirm deletion?'
            content={
                <div className='add-material-popup-success-container'>
                    <Typography style={{color: '#656f71', fontSize: '16px'}}>
                        {`You are about to remove ${materialsToDelete.length} entries.`}
                    </Typography>
                </div>
            }
            buttons={<>
                <Button
                    variant='contained'
                    className='add-material-popup-button'
                    onClick={handleClose}
                >
                    No
                </Button>
                <Button
                    variant='contained'
                    className='add-material-popup-button'
                    onClick={handleRemoveMaterials}
                >
                    Yes
                </Button>
            </>}
            centerButtons={true}
            onClose={handleClose}
        />;
    } else if (showSuccess) {
        return <SuccessPopup
            text={`${removeMaterialsCount} entries were removed`}
            onClose={() => {
                handleUpdate(removeMaterialsCount);
                handleClose();
            }}
        />;
    } else {
        return null;
    }
};
